<template>
  <div id="app" class="app-container">
    <router-view/>
    <Navigation v-if="isLogged" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Navigation from '@/components/Navigation'
export default {
  components: {
    Navigation
  },
  computed: mapState(['isLogged']),
  created () {
    this.$store.dispatch('getLoggedState')
  }
}
</script>
